if (!window.Eurus.loadedScript.includes('express-fee.js')) {
  window.Eurus.loadedScript.push('express-fee.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xExpressFeeCart', () => ({
        init() {
          if (localStorage.getItem("express_fee") && localStorage.getItem("express_fee") == 'true') {
            this.$refs.express_fee.checked = true;
          } else {
            this.$refs.express_fee.checked = false;
          }
        },
        clearCart() {
          localStorage.setItem("express_fee", false);
          fetch(window.Shopify.routes.root + 'cart/clear.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body:  JSON.stringify({ "sections":  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id) })
          })
          .then((response) => response.json())
          .then((response) => {
            this.clearSuccess = true;
            Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
              const sectionElement = document.querySelector(section.selector);
              if (sectionElement) {
                if (response.sections[section.id])
                  sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
              }
            }));
            Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
            document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
          })
          .catch((error) => {
            console.error('Error:', error);
          })           
        },
        async addExpressFee(id_product_fee) {
          const sections = Alpine.store('xCartHelper').getSectionsToRender().map(s => s.id);
          if (this.$refs.express_fee.checked) {
            localStorage.setItem("express_fee", true);
            const formData = {
              items: [
                {
                  id: id_product_fee,
                  quantity: 1
                }
              ],
              'sections': sections
            };
            const formResponse = await window.fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(formData),
            });
            const response = await formResponse.json();
            this._postUpdateItem(response);
          } else {
            localStorage.setItem("express_fee", false);
            const formRemoveData = {
              'id': id_product_fee,
              'quantity': 0,
              'sections': sections
            };
            const formRemoveResponse = await window.fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(formRemoveData),
            });
            const responseRemove = await formRemoveResponse.json();
            this._postUpdateItem(responseRemove);
          }
        },
        _postUpdateItem(parsedState) {
          if (parsedState.status == '422') {
            console.log(parsedState.message);
          } else {
            const items = document.querySelectorAll('.cart-item');
            Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
              const sectionElement = document.querySelector(section.selector);
              if (sectionElement) {
                if (parsedState.sections[section.id])
                  sectionElement.innerHTML = getSectionInnerHTML(parsedState.sections[section.id], section.selector);
              }
            }));
            const currentItemCount = Alpine.store('xCartHelper').currentItemCount
            Alpine.store('xCartHelper').currentItemCount = parsedState.item_count;
            if (currentItemCount != parsedState.item_count) {
              document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
            }
          }
        }
      }));
    })
  });
}